module.exports = __webpack_public_path__ + "media/images/landkit/illustrations/illustration-4-cropped-5ea2556c4006e622ed3b8d75ba68b234.png";